import React from 'react';
import { motion } from 'framer-motion';
export function DreamSection() {
  return <section className="py-20 bg-[#FFF8F0]" data-id="element-21">
      <div className="container mx-auto px-4" data-id="element-22">
        <div className="max-w-3xl mx-auto text-center" data-id="element-23">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-amber-100 relative overflow-hidden" data-id="element-24">
            {/* Decorative sparkles */}
            <div className="absolute top-4 left-4 text-amber-300 text-2xl" data-id="element-25">
              ✨
            </div>
            <div className="absolute bottom-4 right-4 text-amber-300 text-2xl" data-id="element-26">
              ✨
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-amber-600 mb-8 font-serif" data-id="element-27">
              Imagina Esto
            </h2>

            <div className="space-y-6 text-lg md:text-xl text-gray-700 text-left" data-id="element-28">
              <p className="font-bold text-purple-900 text-2xl text-center mb-8" data-id="element-29">
                Día 10 de la quincena.
              </p>

              <p data-id="element-30">
                Abres tu cuenta bancaria… y{' '}
                <span className="font-bold text-purple-700" data-id="element-31">
                  no sientes miedo.
                </span>
              </p>

              <p className="text-2xl font-bold text-pink-600 text-center py-4" data-id="element-32">
                Sientes control.
              </p>

              <ul className="space-y-4 pl-4 md:pl-12" data-id="element-33">
                <li className="flex items-center gap-3" data-id="element-34">
                  <span className="text-amber-500" data-id="element-35">✓</span>
                  Sabes cuánto queda.
                </li>
                <li className="flex items-center gap-3" data-id="element-36">
                  <span className="text-amber-500" data-id="element-37">✓</span>
                  Sabes para qué es.
                </li>
                <li className="flex items-center gap-3" data-id="element-38">
                  <span className="text-amber-500" data-id="element-39">✓</span>
                  Sabes que estás cubierta.
                </li>
              </ul>

              <p className="pt-4" data-id="element-40">
                Tienes un pequeño fondo que te da seguridad.
              </p>
              <p data-id="element-41">Puedes decir “sí” a un plan sin culpa.</p>

              <div className="mt-10 pt-8 border-t border-amber-100 text-center" data-id="element-42">
                <p className="text-gray-500 italic mb-2" data-id="element-43">
                  Eso no es riqueza extrema.
                </p>
                <p className="text-2xl font-bold text-purple-900 mb-6" data-id="element-44">
                  Eso es tranquilidad.
                </p>
                <p className="text-xl" data-id="element-45">
                  Y la tranquilidad financiera no es lujo.
                </p>
                <p className="text-2xl font-bold text-amber-600 mt-2" data-id="element-46">
                  Es necesidad.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}